export default __webpack_public_path__ + "static/media/protergia_ΦΑ.ed535186.png";